import maintainDisabled from 'ally.js/esm/maintain/disabled'; // ES5 code, need to replace Uglify to use the ES6 modules
import queryTabbable from 'ally.js/esm/query/tabbable'; // ES5 code, need to replace Uglify to use the ES6 modules
import {scaleBetween} from './utils.js';


/**
 * Highlights the in-page menu items when scroll to down the page.
 *
 * Add this to all in-page links to highlight the element in the link's href when it comes into view: data-menu-highlight
 */


// console.log('Site:menu');

const observers = {};


document.querySelectorAll('[data-menu-highlight]').forEach((element) => {
  const id = element.getAttribute('href');

  if (!id) {
    return;
  }

  const targetElement = document.querySelector(id);

  if (!targetElement) {
    return;
  }

  const options = {
    rootMargin : '15px 0px 15px 0px',
    threshold  : 0.55,
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(targetElement);

  observers[id.slice(1)] = {
    link   : element,
    target : targetElement,
    observer,
  };
});


function callback(entries, observer) {
  // console.log('Site:menu:callback');
  // console.log('entries', entries);

  for (let i = entries.length - 1; i >= 0; i--) {
    const entry = entries[i];
    const id = entry.target.getAttribute('id');
    const observerData = observers[id];

    if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
      observerData.link.classList.add('active');

      for (const [linkId, data] of Object.entries(observers)) {
        if (linkId !== id) {
          data.link.classList.remove('active');
        }
      }
    }
  }
}


class InPagePages {
  currentPageId = '';
  pageContainer;
  linkContainer;
  panelContainer;
  panel;
  contentContainer;
  closeButton;
  background;
  onMouseDownFn;
  onCloseClickFn;
  onKeyDownFn;
  previousTop;
  startX;
  startY;
  disabledHandle;
  activeElement;


  // id the container which has links to the in-page pages, which must have matching IDs
  constructor(id) {
    // console.log('Site:InPagePages:constructor', id);

    this.onMouseDownFn  = this.onMouseDown.bind(this);
    this.onCloseClickFn = this.onCloseClick.bind(this);
    this.onKeyDownFn   = this.onKeyDown.bind(this);
    this.linkContainer  = document.getElementById(id);

    // console.log('this.linkContainer', this.linkContainer);

    if (!this.linkContainer) {
      return;
    }

    this.init();
  }


  init() {
    // console.log('Site:InPagePages:init');

    this.linkContainer.querySelectorAll('a').forEach((element) => {
      element.setAttribute('aria-expanded', false);
    });
    this.linkContainer.addEventListener('click', this.onLinkClick.bind(this));

    // For testing, immediately opens this page
    // this.open('page-about-us');

    // If a matching has in the URL, open that page immediately
    if (window.location.hash) {
      this.open(window.location.hash.slice(1));
    }
  }


  onLinkClick(event) {
    // console.log('Site:InPagePages:onLinkClick');
    // console.log('event', event);

    if (event.target.tagName !== 'A') {
      return;
    }

    event.preventDefault();

    this.open(event.target.getAttribute('href').slice(1));
  }


  open(pageId) {
    // console.log('Site:InPagePages:open', pageId);

    if (this.currentPageId) {
      // console.log('Page already open, closing');

      this.close();
    }

    const page = document.querySelector('#in-page-pages #' + pageId);

    if (!page) {
      // console.log('Page not found');

      return;
    }

    this.setBodyScrollingEnabled(false);

    this.linkContainer.querySelectorAll('a').forEach((element) => {
      element.setAttribute('aria-expanded', element.getAttribute('href') === '#' + pageId);
    });

    this.pageContainer = page;
    this.currentPageId = pageId;

    const html =
      '<div id="page-overlay" aria-modal="true" role="dialog">' +
        '<div class="background"></div>' +
        '<div class="panel">' +
          '<div class="inner">' +
            '<button class="page-overlay-close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg><span class="visuallyhidden">Close</span></button>' +
            '<div class="page-overlay-content"></div>' +
          '</div>' +
        '</div>' +
      '</div>'
    ;

    this.panelContainer   = new DOMParser().parseFromString(html, 'text/html').body.firstChild;
    this.panel            = this.panelContainer.getElementsByClassName('panel')[0];
    this.background       = this.panelContainer.getElementsByClassName('background')[0];
    this.closeButton      = this.panelContainer.getElementsByClassName('page-overlay-close')[0];
    this.contentContainer = this.panelContainer.getElementsByClassName('page-overlay-content')[0];

    this.contentContainer.append(...this.pageContainer.childNodes);

    window.addEventListener('keydown', this.onKeyDownFn);
    this.panelContainer.addEventListener('mousedown', this.onMouseDownFn);
    this.panelContainer.addEventListener('touchstart', this.onMouseDownFn);
    this.closeButton.addEventListener('click', this.onCloseClickFn);

    document.body.classList.add('panel-open');
    document.body.append(this.panelContainer);

    // Keep focus trapped within the panel
    this.disabledHandle = maintainDisabled({
      filter : this.panelContainer,
    });

    // Init the open animation
    setTimeout(() => {
      this.panelContainer.classList.add('active');
    });

    this.activeElement = document.activeElement;

    // Set focus to the first focusable element in the panel
    const elements = queryTabbable({
      context          : this.panelContainer,
      defaultToContext : true,
    });

    if (elements.length) {
      elements[0].focus();
    }
  }


  close() {
    // console.log('Site:InPagePages:close');

    if (!this.currentPageId) {
      // console.log('Page not open');
    }

    this.panel.addEventListener('transitionend', () => {
      // console.log('transitionend');

      window.removeEventListener('keydown', this.onKeyDownFn);
      this.panelContainer.removeEventListener('mousedown', this.onMouseDownFn);
      this.panelContainer.removeEventListener('touchstart', this.onMouseDownFn);
      this.closeButton.removeEventListener('click', this.onCloseClickFn);

      this.pageContainer.append(...this.contentContainer.childNodes);
      this.panelContainer.remove();

      this.linkContainer.querySelectorAll('a').forEach((element) => {
        element.setAttribute('aria-expanded', false);
      });

      // Disable the focus trap
      this.disabledHandle.disengage();

      if (this.activeElement && this.activeElement !== document.body) {
        // console.log('Active');
        this.activeElement.focus();
      } else {
        // console.log('Fallback');

        // Set focus to the link which matches this panel
        const link = this.linkContainer.querySelectorAll('[href="#' + this.currentPageId + '"]');

        if (link.length) {
          link[0].focus();
        }
      }

      this.currentPageId = '';
    }, {once: true});

    this.background.style.opacity = '';
    this.panel.style.transform = 'translateX(100vw)';
    document.body.classList.remove('panel-open');
    this.setBodyScrollingEnabled(true);
  }


  onCloseClick(event) {
    // console.log('Site:InPagePages:onCloseClick');

    this.close();
  }


  // Handle touch/mouse dragging of the panel to close it
  onMouseDown(event) {
    // console.log('Site:InPagePages:onMouseDown');
    // console.log('event', event);

    // Ignore events on elements the user needs to interact with
    if (['INPUT'].indexOf(event.target.nodeName) !== -1) {
      // console.log('Ignore node type');
      return;
    }

    if (event.touches && event.touches.length > 1) {
      // console.log('Ignore multiple touches');
      return;
    }

    // If a single click is detected on the background layer, close the panel
    if (event.target === this.background) {
      this.startX = event.clientX;
      this.startY = event.clientY;
    } else {
      this.startX = 9999999;
      this.startY = 9999999;
    }

    // This needs to match the value of #menu-primary-mobile.active in _in-page-pages.scss
    const maxOpen = 0.10;

    const startBackgroundOpacity = Number(getComputedStyle(this.background).opacity)
        , panelStartX            = Number(getComputedStyle(this.panel).transform.split(',')[4])
        , startX                 = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX
        , screenWidth            = window.screen.width
    ;

    let distanceFromStart = 0
      , percent
    ;

    document.body.classList.add('panel-interactive');
    this.panel.classList.add('interactive');

    const touchMoveFn = (event) => {
      // console.log('touchmove');
      // console.log('touchmove', event);

      const x = event.type === 'touchmove' ? event.changedTouches[0].clientX : event.clientX;

      distanceFromStart = startX - x;
      percent           = Math.min(Math.max((panelStartX - distanceFromStart) / screenWidth, maxOpen), 1);

      this.panel.style.transform = 'translateX(' + (percent.toFixed(3) * 100) + 'vw)';
      this.background.style.opacity = startBackgroundOpacity * (1 - scaleBetween(percent, 0, 1, maxOpen, 1)).toFixed(2);
    };

    const touchEndFn = (event) => {
      // console.log('touchend');
      // console.log('touchend', event);

      this.panel.removeEventListener('touchmove', touchMoveFn);
      this.panel.removeEventListener('touchend', touchEndFn);
      window.removeEventListener('mousemove', touchMoveFn);
      window.removeEventListener('mouseup', touchEndFn);

      document.body.classList.remove('panel-interactive');
      this.panel.classList.remove('interactive');

      this.panel.style.transform = '';
      this.background.style.opacity = '';

      // console.log('percent', percent);

      // If the panel was dragged far enough to the right, or the background layer was clicked, auto-close it
      if (percent > 0.5 || (this.startX === event.clientX && this.startY === event.clientY)) {
        this.close();
      }
    };

    this.panel.addEventListener('touchmove', touchMoveFn);
    this.panel.addEventListener('touchend', touchEndFn);
    window.addEventListener('mousemove', touchMoveFn);
    window.addEventListener('mouseup', touchEndFn);
  }


  // Captures all keydown, watches for Escape to close the panel
  onKeyDown(event) {
    // console.log('Site:InPagePages:onKeyDown');
    // console.log('event.key', event.key);

    // Do nothing if the event was already processed
    if (event.defaultPrevented) {
      return;
    }

    if (['INPUT', 'TEXTAREA'].indexOf(event.target.tagName) === -1 && event.key === 'Escape') {
      this.close();
    }
  }

  /**
   * Prevents/allows the body to scroll.
   *
   * Used when modals are visible to block scroll chaining.
   *
   * @since 0.1.0
   *
   * @param bool enabled Whether the body can scroll.
   */
  setBodyScrollingEnabled(enabled) {
    // console.log('Site:InPagePages:setBodyScrollingEnabled', enabled);

    const supportPageOffset = 'pageXOffset' in window;
    const isCSS1Compat      = ((document.compatMode || '') === 'CSS1Compat');
    const y                 = supportPageOffset ? window.pageYOffset : (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop); /* eslint-disable-line */

    // console.log('y', y);

    if (enabled) {
      // Allow the parent document to be scrollable again
      document.body.classList.remove('panel-open');

      document.body.style.position = 'inherit';
      document.body.style.width    = 'inherit';
      document.body.style.top      = 'inherit';

      window.scrollTo({
        top : this.previousTop,
      });
    } else {
      this.previousTop = y;

      document.body.style.position = 'fixed';
      document.body.style.width    = '100%';
      document.body.style.top      = '-' + y + 'px';
    }
  }
}


/* eslint-disable-next-line */
const headerPages = new InPagePages('in-page-header-pages-links');
const footerPages = new InPagePages('in-page-footer-pages-links');

